import { useEffect } from "react";

/**
 * The document title for one page.
 *
 * A single-page app keeps whatever title index.html shipped with unless
 * something sets it, so every route here read "HIL - Teleste" - which is the
 * one thing the brand book's web section rules out, asking for titles that are
 * unique per page and describe the content. It also matters away from the
 * brand: browser history, a row of pinned tabs and a bookmark all show this
 * string and nothing else, and "HIL - Teleste" six times over is unusable.
 *
 * Restores the previous title on unmount so a page that unmounts without
 * another mounting (an error boundary, a redirect) does not leave its own
 * heading behind.
 */
export function useTitle(title: string): void {
  useEffect(() => {
    const previous = document.title;
    document.title = title ? `${title} - HIL` : "HIL";
    return () => {
      document.title = previous;
    };
  }, [title]);
}
